import axios from "axios";
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { AxiosRequestConfig, AxiosRequestHeaders } from "axios";
import { useDispatch } from "react-redux";
import { setWholeAlert } from "../store/commonplace";
const instance = axios.create({
  baseURL: process.env.REACT_APP_URL,
});
instance.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    const token = localStorage.getItem("token");
    if (token) {
      (config.headers as AxiosRequestHeaders)["amblvenue-satoken"] = token;
    }
    let venueId = sessionStorage.getItem("currentOperateId")
      ? sessionStorage.getItem("currentOperateId")
      : ("0" as any);
    (config.headers as AxiosRequestHeaders)["venueId"] =
      venueId === "all" ? 0 : venueId;
    (config.headers as AxiosRequestHeaders)["Accept-Language"] = "en-US";
    (config.headers as AxiosRequestHeaders)["Cross-Origin-Opener-Policy"] =
      "same-origin";
    (config.headers as AxiosRequestHeaders)["Cross-Origin-Embedder-Policy"] =
      "require-corp";
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

const AxiosInterceptor = ({ children }: any) => {
  const dispatch = useDispatch();

  const location = useLocation();

  const navigate = useNavigate();
  useEffect(() => {
    const resInterceptor = (response: any) => {
      let code = response.data.code;
      if (code === 50000 || code === 50001 || code === 50002) {
        if (location.pathname === "/login" || location.pathname === "/reset") {
          return response;
        } else {
          sessionStorage.clear();
          localStorage.clear();
          navigate("/login");
          return;
        }
      } else if (code === 30002 || code === 30011) {
        dispatch(
          setWholeAlert({
            next: "suspended",
          })
        );
        return;
      } else if (code === 30003) {
        dispatch(
          setWholeAlert({
            next: "deleted",
          })
        );
        return;
      } else {
        return response;
      }
    };

    const errInterceptor = (error: any) => {
      return Promise.reject(error);
    };

    const interceptor = instance.interceptors.response.use(
      resInterceptor,
      errInterceptor
    );

    return () => instance.interceptors.response.eject(interceptor);
  }, []);

  return children;
};

export default instance;
export { AxiosInterceptor };
